import React, { useState, useCallback } from 'react'
import { Link } from 'gatsby'

import remark from 'remark'
import recommended from 'remark-preset-lint-recommended'
import remarkHtml from 'remark-html'

import styled from 'styled-components'

import moment from 'moment'
import 'moment/locale/es'

import Video from '@/components/Video'
import Countdown from '@/components/Countdown'
import RegisterForm from '@/components/RegisterForm'

import SmallAuthor from '@/components/Author/SmallAuthor'
import FullAuthor from '@/components/Author/FullAuthor'

import Banner from '@/components/Banner'

import { StParagraphs, StAvatar, StSep1 } from './style.css'

import { dasherize } from '@/utilities'

const LogoHeight = styled.div`
  margin-bottom: 1rem;

  img {
    display: block;
    max-height: 3rem;
    max-width: 8rem;
    margin-left: auto;
    margin-right: auto;
  }
`

const StCredits = styled.div`
  border: 1px solid #ccc;
  padding: 2rem;
  margin: 1rem auto;
  max-width: 800px;
  text-align: center;
  @media (max-width: 800px) {
    max-width: 100%;
    margin: 1rem 2rem;
  }
  .auspicio {
    border-bottom: 2px solid #ccc;
    margin-bottom: 2rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    .col1 {
      justify-self: flex-end;
      font-size: 1.8rem;
    }
    .col2 {
      justify-self: flex-start;
    }
    img {
      min-height: 100px;
      min-width: 300px;
      @media (max-width: 800px) {
        min-width: 240px;
      }
    }
    @media (max-width: 800px) {
      grid-template-columns: 1fr;
      .col1 {
        justify-self: center;
      }
      .col2 {
        justify-self: center;
      }
    }
  }
  .gremios {
    img {
      display: block;
      max-width: 100%;
      margin: 1rem auto;
    }
  }
`

const Register = ({
  title,
  downtitle,
  slug,
  pretitle,
  video,
  author,
  presenter,
  webinarmeta,
  webinarid,
  bannerhtml,
}) => {
  const { description } = video
  const { start, end, about, place, promovideo } = webinarmeta

  // const htmlbio = remark()
  //   .use(recommended)
  //   .use(remarkHtml)
  //   .processSync(bio)
  //   .toString()

  const htmldescription = remark()
    .use(recommended)
    .use(remarkHtml)
    .processSync(description)
    .toString()

  const htmlabout = remark()
    .use(recommended)
    .use(remarkHtml)
    .processSync(about)
    .toString()

  const event = {
    id: webinarid,
    startTime: start,
    endTime: end,
    location: place,
    title: title,
    description: description,
  }

  const startFormatted = moment(start).locale('es').format('LLLL')

  const htmlbanner = remark()
    .use(recommended)
    .use(remarkHtml)
    .processSync(bannerhtml)
    .toString()

  const inserter = (originalString, insertText, textToSearch) => {
    const position = originalString.indexOf(textToSearch)
    if (position === -1) {
      return originalString
    }
    const pair = Array.from(originalString)
    pair.splice(position, 0, insertText)
    return pair.join('')
  }

  const toInsert = inserter(title, '<br />', downtitle)

  return (
    <div className="mx-auto text-center">
      <div className="bg-white text-black">
        <div className="mx-auto sm:grid sm:grid-cols-2">
          <div className="pt-4 max-w-screen-md mx-auto flex items-center">
            <div className="wrap-title sm:p-8 p-4">
              <h1 className="leading-none mb-6 text-2xl font-bold sm:text-4xl ">
                {pretitle && (
                  // <small className="block uppercase font-light mb-2">
                  //   {pretitle}
                  // </small>
                  <img
                    className="block mx-auto mb-4"
                    src="https://minio.lab.ltnext.com/strapi/logo_572bad6f1f.jpeg"></img>
                )}

                {downtitle && title.indexOf(downtitle) !== -1 ? (
                  <span dangerouslySetInnerHTML={{ __html: toInsert }}></span>
                ) : (
                  <span> {title}</span>
                )}
              </h1>
              <div
                className={`mx-auto grid max-w-sm grid-cols-${
                  author && author.length ? author.length : '1'
                }`}>
                {author &&
                  author.length > 0 &&
                  author.map((eauthor, index) => (
                    <SmallAuthor key={index} data={eauthor} />
                  ))}
              </div>
              {presenter &&
                presenter.length > 0 &&
                presenter.map((epresenter, index) => (
                  <h5 key={index} className="leading-none">
                    Presenta: <strong>{epresenter.fullname}</strong>
                    <br />
                    {epresenter.title}
                  </h5>
                ))}

              <h3 className="font-bold text-2xl sm:text-3xl leading-none mt-4 mb-4 capitalize">
                {startFormatted} <br /> {place}
              </h3>
              <Countdown datetime={start}>
                <Link
                  to={`/webinar/${dasherize(slug)}/`}
                  className="bg-rojo-900 text-white text-sm text-center block px-4 sm:px-10 py-2 sm:py-3 rounded-lg hover:bg-red-900 transition-colors ease-in-out duration-300 ">
                  Ver aquí
                </Link>
              </Countdown>
            </div>
          </div>

          <div className="bg-white sm:px-8 px-2 py-16 ">
            <div className="bg-gris-300 pt-4 max-w-screen-md mx-auto">
              <RegisterForm event={event} />
            </div>
          </div>
        </div>
      </div>

      {promovideo && (
        <div className="mx-auto max-w-screen-lg text-left bg-white pt-4 sm:col-span-8 col-span-12 row-span-2 max-w-screen-md mx-auto">
          <Video video={promovideo} />
        </div>
      )}
      <div class="container mx-auto sm:px-4 px-2 py-16 lg:px-20 text-center">
        <div className="grid grid-cols-12 mt-4">
          <div className="bg-white pt-4 sm:col-span-8 col-span-12">
            <div className="mx-auto max-w-screen-lg text-left">
              <div className="bg-white pt-4 pb-4 sm:col-span-8 col-span-12">
                <StSep1>
                  <h6 className="sm:px-8 px-4 py-2">
                    <span className="font-bold block leading-tight">
                      Detalles
                    </span>{' '}
                    <small className="block leading-none">Sobre el video</small>
                  </h6>
                </StSep1>
                <div className="wrap-description sm:px-8 px-4 py-2">
                  <StParagraphs
                    className=""
                    dangerouslySetInnerHTML={{ __html: htmlabout }}
                  />
                </div>
                <StSep1>
                  <h6 className="about-title sm:px-8 px-4 py-0 mt-4 uppercase">
                    <small className="font-bold">Acerca de los invitados</small>
                  </h6>
                </StSep1>
                <div>
                  {author &&
                    author.length >= 0 &&
                    author.map((eauthor, index) => (
                      <FullAuthor key={index} data={eauthor} />
                    ))}
                </div>

                <StCredits>
                  <div className="auspicio">
                    <div className="col1">
                      <span>Con el auspicio de:</span>
                    </div>
                    <div className="col2">
                      <img
                        src="https://minio.lab.ltnext.com/strapi/logo-huawei_ed33725fa4.svg"
                        alt=""
                      />
                    </div>
                  </div>

                  <div className="">
                    <span>Colaboran</span>
                    <br />
                    <LogoHeight>
                      <div className="logo">
                        <img
                          src="https://minio.lab.ltnext.com/strapi/Image_3_cd68f84fa9.png"
                          alt=""
                        />
                      </div>
                    </LogoHeight>
                  </div>
                  <div className="gremios mx-auto max-w-sm">
                    <p>
                      Agradecemos la colaboración de la Red de Gremios
                      Regionales de SOFOFA, en especial a los gremios de CIDERE
                      (Región de Coquimbo) y ASIVA (Región de Valparaíso);
                      quienes aportaron su visión sobre los desafíos y
                      oportunidades de sus regiones en este contexto de
                      pandemia.
                    </p>
                    <img
                      src="https://minio.lab.ltnext.com/strapi/logo-valpo_6e2361a946.png"
                      alt=""
                    />
                  </div>
                </StCredits>
              </div>
            </div>
          </div>
          <div className="bg-white pt-4 sm:col-span-4 col-span-12">
            <Banner html={htmlbanner} maxwidth="300px" maxheight="600px" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Register
